export default "__VITE_ASSET__8c66a958__"